/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { EliminarAlquiler, IFormBaja } from 'utils/models/interfaces';
import ModalConfirmacion from 'components/public/Modal/ModalConfirmacion';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormControlLabel, Checkbox, Button, Box } from '@mui/material';
import Modal from 'components/public/Modal/Modal';
import { Controller, useForm } from 'react-hook-form';
import { datosFormBaja } from 'utils/formData';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import { UsuarioDTO } from 'utils/models/types';
import { fetchUsuarioId } from 'utils/redux/features/usuarioIdSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import { useError } from 'services/ErrorContext';
import { bajaUsuarioPut } from 'services/servicioPut';
import { useAuth } from 'utils/hooks/useAuth';
import Alerta from 'components/public/Alerta.tsx/Alerta';
import { eliminarAlquiler } from 'services/servicioDelete';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import { anchoMaxLogueado } from 'utils/constants';
import { fetchAlquilerId } from 'utils/redux/features/alquilerIdSlice';

const FormBaja = () => {
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: UsuarioDTO = usuarioJSON && JSON.parse(usuarioJSON);
  const { id } = useParams(); // Id usuario o alquiler a eliminar
  const idUsuarioAEliminar = Number(id);
  const esAdmin = usuario?.Rol === 'Administrador';
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const [mensajeExito, setMensajeExito] = useState('');
  const dispatch = useDispatch<AppDispatch>();
  const { usuario: usuAEliminar, loadingUsuario, errorUsuario } = useSelector((state: RootState) => state.usuarioId);
  const { loadingAlquiler, errorAlquiler } = useSelector((state: RootState) => state.alquilerId);
  const { error, setError, clearError, setLoading } = useError();

  const { logout } = useAuth();
  const location = useLocation();
  const datosBaja = datosFormBaja[0];
  const { name, label } = datosBaja;
  const borrarAOtroUsu = !location.pathname.includes('usuario/baja');
  const opcionEliminarAlquiler = location.pathname.includes('alquiler');

  const onClose = () => {
    setOpenModal(false);
  };

  const onConfirm = async (data: IFormBaja) => {
    setOpenModal(false);
    clearError();

    if (opcionEliminarAlquiler) {
      const requestEliminarAlq: EliminarAlquiler = { IdAlquiler: Number(id) };

      try {
        await eliminarAlquiler(requestEliminarAlq, setError, setLoading);
        setMensajeExito('¡Alquiler eliminado correctamente!');
      } catch (error) {
        console.error('Error en la eliminación:', error);
      }
    } else {
      const request: IFormBaja = { idUsuario: idUsuarioAEliminar };

      try {
        await bajaUsuarioPut(request, setError, setLoading);

        if (esAdmin && usuario.Id !== idUsuarioAEliminar) {
          setMensajeExito('Baja de usuario correcta. Te redirigiremos de vuelta al listado de Usuarios.');
          setTimeout(() => {
            navigate('/admin/usuarios');
          }, 5000);
        } else {
          setMensajeExito('Baja de usuario correcta. Te redirigiremos a la página de inicio.');
          setTimeout(() => {
            logout(setError, setLoading);
            navigate('/');
          }, 5000);
        }
      } catch (error) {
        console.error('Error en la inactivación del usuario:', error);
      }
    }
  };

  const onCancel = () => {
    esAdmin ? navigate('/admin') : navigate('/usuario');
  };

  useEffect(() => {
    if (opcionEliminarAlquiler) {
      id && dispatch(fetchAlquilerId(Number(id))); // Obtener alquiler a eliminar
    } else {
      id && dispatch(fetchUsuarioId(Number(id))); // Obtener usuario a eliminar
    }
  }, []);

  const { control, handleSubmit, watch } = useForm<IFormBaja>({
    defaultValues: {
      idUsuario: 0,
    },
  });
  const isChecked = watch(name);

  // Lo dejo en caso de que en el futuro se incorpore un sistema de cobro de cuotas de socio
  const mostrarAviso = (usuAEliminar?.EsAlumno || usuAEliminar?.TipoSocio !== 'Nada') && !opcionEliminarAlquiler;
  const mensajeAviso = usuAEliminar
    ? 'Para poder concretar la baja, se deben hacer las gestiones necesarias para que el usuario quede libre de suscripciones.'
    : 'Para poder concretar la baja, te solicitamos que te comuniques con nuestro equipo completando el formulario de contacto.';

  const titulo = opcionEliminarAlquiler
    ? '¿Estás seguro/a de querer eliminar este alquiler?'
    : borrarAOtroUsu
      ? `¿Estás seguro/a de eliminar al usuario ${usuAEliminar?.Nombre} ${usuAEliminar?.Apellido}?`
      : '¿Estás seguro/a que querés darte de baja?';

  const mensajeConfirmacion = opcionEliminarAlquiler
    ? 'Esta acción no se puede deshacer.'
    : usuAEliminar
      ? 'Una vez confirmada la desuscripción, se perderá todo el historial de talleres y reservas. ¿Deseas continuar?'
      : 'Una vez confirmada la desuscripción, perderás todo tu historial de talleres y reservas. ¿Deseas continuar?';

  return (
    <DashboardContainer>
      <Alerta mensaje={mensajeExito} abierto={!!mensajeExito} severity="success" />
      {/* @ts-expect-error -- Alerta prop type mismatch */}
      <Alerta mensaje={error} abierto={!!error} severity="error" />
      {loadingUsuario || loadingAlquiler ? (
        <Spinner />
      ) : errorUsuario || errorAlquiler ? (
        <NoResponse />
      ) : (
        <>
          <Box component="form" maxWidth={anchoMaxLogueado} mx="auto">
            {mostrarAviso ? (
              <Modal
                open={openModal}
                onClose={onClose}
                titulo="No es posible borrar el usuario"
                mensaje={mensajeAviso}
              />
            ) : (
              <ModalConfirmacion
                mensaje={mensajeConfirmacion}
                open={openModal}
                onConfirm={handleSubmit(onConfirm)}
                onClose={onClose}
                titulo="¿Estás seguro/a?"
              />
            )}
            <Typography sx={{ margin: '40px auto 15px auto', maxWidth: '500px', fontWeight: 'bold' }}>
              {titulo}
            </Typography>
            <Box>
              <Controller
                name={name}
                control={control}
                render={({ field }) => <FormControlLabel control={<Checkbox {...field} />} label={label} />}
              />
              <Box marginTop="15px" display="flex" gap="10px" justifyContent="center">
                <Button variant="outlined" color="info" type="button" onClick={onCancel}>
                  Cancelar
                </Button>
                <Button variant="contained" onClick={() => setOpenModal(true)} disabled={!isChecked}>
                  Confirmar
                </Button>
              </Box>
            </Box>
          </Box>
        </>
      )}
    </DashboardContainer>
  );
};

export default FormBaja;
